var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "documentCardObserver", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-10 text-bold bold" }, [
          _c("i", { staticClass: "fa fa-file-upload color-orange" }),
          _vm._v(" Sección de Documentos ")
        ]),
        _c(
          "div",
          { staticClass: "col-md-2 text-right" },
          [
            _c("action-button", {
              staticClass: "pl-3 transparent",
              attrs: { i: "fas fa-times-circle" },
              on: {
                click: function($event) {
                  return _vm.$emit("on-cancel")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", { staticClass: "mt-3" }, [_vm._v("Anejar Documentos")])
        ]),
        _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg":
                            "Favor seleccionar un Tipo de Documento",
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Tipo de Documento:",
                          options: _vm.documentTypes,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.document.documentTypeId,
                          callback: function($$v) {
                            _vm.$set(_vm.document, "documentTypeId", $$v)
                          },
                          expression: "document.documentTypeId"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-5" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-file-input", {
                        ref: "fileUpload2",
                        attrs: {
                          accept: ".pdf",
                          "attachment-id": _vm.document.Id,
                          error: errors[0],
                          label: "Archivo:",
                          "label-position": "left",
                          "max-size": 10,
                          name: _vm.document.FileName,
                          required: "",
                          value: _vm.document.File
                        },
                        model: {
                          value: _vm.document.File,
                          callback: function($$v) {
                            _vm.$set(_vm.document, "File", $$v)
                          },
                          expression: "document.File"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-4 text-right mt-4 pt-1" },
          [
            _c(
              "action-button",
              {
                attrs: {
                  i: "fas fa-times-circle",
                  variant: "outline-danger mr-3"
                },
                on: {
                  click: function($event) {
                    return _vm.clearForm()
                  }
                }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "action-button",
              {
                attrs: { i: "fas fa-save", variant: "success" },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ]),
      _vm.documents.length
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("label", { staticClass: "mt-3" }, [
                _vm._v("Documentos Anejados")
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.documents, function(item) {
                return _c(
                  "callout",
                  {
                    key: item.documentId,
                    ref: "callout",
                    refInFor: true,
                    staticClass: "w-100 mt-3",
                    attrs: { "has-border": false, "has-toggle": false }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-5" }, [
                        _c("div", { staticClass: "data-label" }, [
                          _vm._v("Tipo de documento:")
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(item.documentTypeName))
                        ])
                      ]),
                      _c("div", { staticClass: "col-md-5" }, [
                        _c("div", { staticClass: "data-label" }, [
                          _vm._v("Archivo:")
                        ]),
                        _c("span", { staticClass: "data" }, [
                          _vm._v(_vm._s(item.filename))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-md-2 d-flex" },
                        [
                          _c("drop-down", {
                            staticClass: "align-self-center",
                            attrs: {
                              "data-item": item,
                              items: _vm.actionItems,
                              responsive: true
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.pagination.totalItemCount > _vm.pagination.perPage
                  ? _c("pagination", {
                      attrs: { data: _vm.pagination, "show-text": true },
                      on: { "pagination-go-page": _vm.onSearch }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }